//
// ステート
//
import init from './init'

export default {
  // 予約番号
  rid: 0,

  // 店舗ID
  shopid: 0,

  // 予約可能期間
  allow: { ...init.allow },

  // 予約期間
  period: { ...init.period },

  // 車両ID
  carid: 0,

  // オプション
  options: {},
  gears: {},

  // 返却場所
  locationid: 0,

  // 送迎・配車
  pick: 0,
  deli: 0,

  // 免責補償
  insuranceid: 0,

  // 利用人数
  peoples: 1,

  // クーポンコード
  couponCode: '',

  // 連絡事項
  note: '',

  // 料金
  charge: { ...init.charge }
}
